// @ts-nocheck

export const CLEAR_SCRAPER_DATA = 'CLEAR_SCRAPER_DATA';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const clearScraperData = () => ({
  type: CLEAR_SCRAPER_DATA,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});
